import { z } from 'zod';
// Lives apart from chat.ts because chat.ts imports chat-buttons.ts, which needs this schema.
export const ConversationChannelSchema = z.enum(['web', 'whatsapp']);
